import { useAppSelector } from '@/store/hook'
import { selectHasSessionBasedShoppingCart } from '@/store/selectors/userSelector'
import { getSessionCookieKey } from '@/contexts/punchout/sessionCookieKeyStore'
import { SESSION_BASED_EXPIRY_TIME } from '@/libs/constants'
import { getCookie, renewCookie } from '@/libs/utils/cookies'

function useSessionId() {
  const hasSessionBasedShoppingCart = useAppSelector(
    selectHasSessionBasedShoppingCart,
  )

  if (hasSessionBasedShoppingCart) {
    const sessionId = getCookie(getSessionCookieKey())

    if (!sessionId) {
      renewCookie(getSessionCookieKey(), SESSION_BASED_EXPIRY_TIME)
    }

    return {
      sessionId: getCookie(getSessionCookieKey()),
    }
  }

  return {}
}

export { useSessionId }
